import BlockType115Component from '@headlines/components/block/111-120/BlockType115.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType115: AdminBlockType = {
  component: BlockType115Component,
  attributes: AdminBlockTypeAttributes({}),
  articlesCount: 0,
};

export default AdminBlockType115;
